import React from 'react';
import { Route, Routes } from 'react-router-dom';
import FavoritesPage from 'src/pages/favorites';
import Home from 'src/pages/home-page';
import LearningArtifactDetailPage from 'src/pages/learning-artifact-detail-page';
import NotFoundPage from 'src/pages/not-found-page/not-found-page';
import { useNotifications } from './providers/NotificationsProvider';
import { Flashbar } from '@cloudscape-design/components';
import SearchPage from 'src/pages/search-page';
import RecentlyViewed from 'src/pages/recently-viewed';
import { InfoBanner } from './InfoBanner';
import UrlTracker from 'src/components/UrlTracker';
import useHistoryStack from 'src/hooks/useHistoryStack';
import MaintenancePage from 'src/pages/maintenance-page/maintenance-page';
import { MaintenanceMiddleware } from 'src/components/middleware/maintenance-middleware';
import NumericRoute from 'src/components/NumericRoute/NumericRoute';
import ErrorPage from 'src/pages/error-page/error-page';
import ContentPolicyPage from 'src/pages/content-policy';

interface AppRoutesProps {
    setExploreModalOpen: (open: boolean) => void;
}

export const AppRoutes = ({ setExploreModalOpen }: AppRoutesProps) => {
    const { previousPath } = useHistoryStack();
    const { notifications } = useNotifications();
    return (
        <MaintenanceMiddleware>
            <InfoBanner />
            {notifications.length > 0 && (
                <Flashbar items={notifications} data-notifications-flashbar />
            )}
            <UrlTracker />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route
                    path="/not-found"
                    element={<NotFoundPage path={previousPath} />}
                />
                <Route
                    path="/maintenance"
                    element={
                        <MaintenancePage
                            maintenanceStatus={{
                                isInMaintenance: true,
                                message:
                                    'We are upgrading our systems to serve you better.',
                            }}
                        />
                    }
                />
                <Route path="/error" element={<ErrorPage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/favorites" element={<FavoritesPage />} />
                <Route path="/recent" element={<RecentlyViewed />} />
                <Route path="/content-policy" element={<ContentPolicyPage />} />
                <Route
                    path="/:artifactId"
                    element={
                        <NumericRoute>
                            <LearningArtifactDetailPage
                                setExploreModalOpen={setExploreModalOpen}
                            />
                        </NumericRoute>
                    }
                />
                <Route
                    path="*"
                    element={<NotFoundPage path={previousPath} />}
                />
            </Routes>
        </MaintenanceMiddleware>
    );
};
